<template>
  <div class="">
    <lm-label>Select the Feed source:</lm-label>
    <ul class="PickerList">
      <li
        v-for="source in sources"
        :key="source.type"
        class="min-h-32 py-4 px-2 cursor-pointer border hover:bg-gray-200"
        :class="{
          'bg-gray-200 border-gray-700': value === source.type
        }"
        @click="onSelect(source)"
      >
        <header class="flex items-center mb-2">
          <lm-icon
            size="21"
            :icon="source.type.toLowerCase()"
            class="mr-2 text-gray-700"
          />
          <h1
            class="text-xs text-gray-700"
            :class="{'text-gray-900': value === source.type}"
          >
            {{ source.label }}
          </h1>
        </header>
        <p class="mb-0 text-xxs text-gray-500">{{ source.description }}</p>
      </li>
    </ul>
    <span
      v-if="error"
      class="flex items-center mt-3 pt-1 text-error text-xs border-t border-error"
    >
      Please select a feed type
    </span>
  </div>
</template>
<script>
import LmLabel from '@/components/ui/LmLabel'
import {mapGetters} from 'vuex'
import LmIcon from '@/components/ui/LmIcon'
import {
  FeedSources,
  FeedSourcesLabels,
  FeedSourcesDescription
} from '@/lib/definitions'

export default {
  name: 'FeedSourcesPicker',
  components: {
    LmLabel,
    LmIcon
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      error: false
    }
  },
  computed: {
    ...mapGetters(['hasFeedType']),
    sources() {
      return Object.keys(FeedSources)
        .filter(type => type !== FeedSources.WATSON && this.hasFeedType(type))
        .map(type => ({
          type,
          label: FeedSourcesLabels[type],
          description: FeedSourcesDescription[type]
        }))
    }
  },
  methods: {
    onSelect(source) {
      this.clearErrors()
      this.$emit('input', source.type)
    },
    validateData() {
      this.error = false
      if (this.value) return true
      this.error = true
      return false
    },
    clearErrors() {
      this.error = false
    },
    reset() {
      this.clearErrors()
    }
  }
}
</script>

<style scoped>
.PickerList {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-gap: 12px;
}
</style>
